/* 7CAM: mobilmeny, nedräkning, paketpriser, leveransdatum, fast köprad,
   filterlägen, dela-knapp, rörelse (framkallning vid scroll) och mjuk scroll (Lenis). Allt initieras om när en sektion laddas om i temaeditorn.
   Inget beror på requestAnimationFrame; scroll-händelser räcker. */
(function () {
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* ---------- Mobilmeny ---------- */
  function initMenu(root) {
    root.querySelectorAll('[data-c7-menu-toggle]').forEach(function (btn) {
      if (btn.dataset.c7Bound) return;
      btn.dataset.c7Bound = '1';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      var set = function (open) {
        btn.setAttribute('aria-expanded', String(open));
        panel.hidden = !open;
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
      panel.addEventListener('click', function (e) { if (e.target.closest('a')) set(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
      window.matchMedia('(min-width: 900px)').addEventListener('change', function (m) { if (m.matches) set(false); });
    });
  }

  /* ---------- Nedräkning ---------- */
  function initCountdowns(root) {
    root.querySelectorAll('[data-c7-countdown]').forEach(function (el) {
      if (el.dataset.c7Bound) return;
      el.dataset.c7Bound = '1';
      var target = new Date(el.getAttribute('data-c7-countdown')).getTime();
      if (isNaN(target)) return;
      var set = function (k, v) { var n = el.querySelector('[data-cd="' + k + '"]'); if (n) n.textContent = pad(v); };
      var tick = function () {
        var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
        set('d', Math.floor(s / 86400)); s %= 86400;
        set('h', Math.floor(s / 3600)); s %= 3600;
        set('m', Math.floor(s / 60));
        set('s', s % 60);
      };
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- Paketpriser: sätter antalet i Dawns produktformulär ---------- */
  function initBundles(root) {
    root.querySelectorAll('[data-c7-bundles]').forEach(function (fs) {
      if (fs.dataset.c7Bound) return;
      fs.dataset.c7Bound = '1';
      var qty = fs.querySelector('[data-c7-qty]');
      fs.addEventListener('change', function (e) {
        if (e.target.type !== 'radio' || !qty) return;
        qty.value = e.target.value;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ---------- Leverans: brytpunkt i dag + beräknat leveransintervall ---------- */
  function initDelivery(root) {
    root.querySelectorAll('[data-c7-delivery]').forEach(function (el) {
      if (el.dataset.c7Bound) return;
      el.dataset.c7Bound = '1';
      var cutoffH = Number(el.dataset.cutoff || 14);
      var minD = Number(el.dataset.min || 1), maxD = Number(el.dataset.max || 3);
      var days = (el.dataset.days || '').split(','), months = (el.dataset.months || '').split(',');
      var isWeekday = function (d) { return d.getDay() > 0 && d.getDay() < 6; };
      var addBiz = function (d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isWeekday(x)) n--; } return x; };
      var fmt = function (d) { return (days[d.getDay()] || '') + ' ' + d.getDate() + ' ' + (months[d.getMonth()] || ''); };
      var cut = el.querySelector('[data-c7-cutoff]'), arr = el.querySelector('[data-c7-arrives]');
      var tick = function () {
        var now = new Date(), cutoff = new Date(now); cutoff.setHours(cutoffH, 0, 0, 0);
        var today = isWeekday(now) && now < cutoff;
        var ship = today ? now : addBiz(now, 1);
        if (cut) {
          if (today) {
            var ms = cutoff - now, h = Math.floor(ms / 36e5), m = Math.floor((ms % 36e5) / 6e4);
            cut.innerHTML = (el.dataset.tToday || '').replace('[time]', '<b>' + h + ':' + pad(m) + '</b>');
          } else {
            cut.innerHTML = (el.dataset.tLater || '').replace('[day]', '<b>' + fmt(ship) + '</b>');
          }
        }
        if (arr) arr.innerHTML = (el.dataset.tArrives || '').replace('[from]', '<b>' + fmt(addBiz(ship, minD)) + '</b>').replace('[to]', '<b>' + fmt(addBiz(ship, maxD)) + '</b>');
      };
      tick();
      setInterval(tick, 30000);
    });
  }

  /* ---------- Fast köprad: visas när Dawns köpknapp är ur bild ---------- */
  function initSticky(root) {
    root.querySelectorAll('[data-c7-sticky]').forEach(function (bar) {
      if (bar.dataset.c7Bound) return;
      bar.dataset.c7Bound = '1';
      var target = document.getElementById(bar.dataset.target);
      if (!target) return;
      var btn = bar.querySelector('button');
      var footer = document.querySelector('.c7-foot');
      var check = function () {
        var r = target.getBoundingClientRect();
        var pastBuy = r.bottom < 0;
        var atFooter = footer && footer.getBoundingClientRect().top < window.innerHeight;
        var on = pastBuy && !atFooter;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', String(!on));
        btn.tabIndex = on ? 0 : -1;
      };
      btn.addEventListener('click', function () {
        if (target.disabled) return;
        target.click();
      });
      // Spegla Dawns knapp (slutsåld/variantbyte)
      new MutationObserver(function () {
        btn.disabled = target.disabled;
        var label = target.querySelector('span');
        if (label && label.textContent.trim()) btn.textContent = label.textContent.trim();
      }).observe(target, { attributes: true, childList: true, subtree: true });
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  }

  /* ---------- Filterlägen ---------- */
  function initModes(root) {
    root.querySelectorAll('[data-c7-modes]').forEach(function (sec) {
      if (sec.dataset.c7Bound) return;
      sec.dataset.c7Bound = '1';
      var tabs = sec.querySelectorAll('[data-c7-mode]');
      var frames = sec.querySelectorAll('[data-c7-frame]');
      var show = function (i) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.dataset.c7Mode === i)); });
        frames.forEach(function (f) {
          var on = f.dataset.c7Frame === i;
          if (on && f.hidden) {
            // Liten blixt i bilden när läget byts
            f.classList.remove('is-flash');
            void f.offsetWidth;
            f.classList.add('is-flash');
          }
          f.hidden = !on;
        });
      };
      tabs.forEach(function (t) {
        t.addEventListener('click', function () { show(t.dataset.c7Mode); });
      });
      // Temaeditorn: markera ett block → visa det läget
      sec.addEventListener('shopify:block:select', function (e) {
        var t = e.target.closest('[data-c7-mode]');
        if (t) show(t.dataset.c7Mode);
      });
    });
  }

  /* ---------- Dela droppen ---------- */
  function initShare(root) {
    root.querySelectorAll('[data-c7-share]').forEach(function (btn) {
      if (btn.dataset.c7Bound) return;
      btn.dataset.c7Bound = '1';
      btn.addEventListener('click', function () {
        var url = btn.dataset.url, text = btn.dataset.text;
        if (navigator.share) {
          navigator.share({ title: '7CAM', text: text, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(text + ' ' + url).then(function () {
            var label = btn.lastChild, old = label.textContent;
            label.textContent = btn.dataset.copied;
            setTimeout(function () { label.textContent = old; }, 2200);
          });
        }
      });
    });
  }


  /* ---------- Produktvideo direkt i galleriet ----------
     Spelar bara när videon syns (sparar batteri/data). Dawn pausar ALL media vid
     bildbyte i galleriet, därför kollas synligheten igen vid scroll och slideChanged. */
  var vids = [];
  function checkVids() {
    var vh = window.innerHeight;
    vids.forEach(function (v) {
      var r = v.getBoundingClientRect();
      var visible = r.bottom > 0 && r.top < vh && r.right > 0 && r.left < window.innerWidth && r.width > 0;
      if (visible && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!visible && !v.paused) v.pause();
    });
  }
  function initVideos(root) {
    root.querySelectorAll('[data-c7-vid]').forEach(function (wrap) {
      if (wrap.dataset.c7Bound) return;
      wrap.dataset.c7Bound = '1';
      var v = wrap.querySelector('video');
      if (!v) return;
      v.muted = true; v.playsInline = true; v.loop = true;
      vids.push(v);
      var btn = wrap.querySelector('[data-c7-vid-sound]');
      if (btn) btn.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.textContent = v.muted ? btn.dataset.on : btn.dataset.off;
        if (v.paused) v.play().catch(function () {});
      });
    });
    checkVids();
  }
  window.addEventListener('scroll', checkVids, { passive: true });
  window.addEventListener('resize', checkVids);
  document.addEventListener('slideChanged', function () { setTimeout(checkVids, 50); }, true);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) checkVids(); });


  /* ---------- Blixt när något läggs i varukorgen ----------
     Lyssnar på alla formulär mot /cart/add (även fasta köpraden, som klickar Dawns knapp).
     Av via headerns inställning eller prefers-reduced-motion. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    if (!document.querySelector('[data-c7-flash]')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var el = document.createElement('div');
    el.className = 'c7-flash';
    el.setAttribute('aria-hidden', 'true');
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 900);
  }, true);

  /* ---------- Rörelse: innehåll "framkallas" när det rullar in ----------
     Bara när <html> har c7-motion (sätts i <head>, inte i temaeditorn eller vid reducerad rörelse).
     Det som redan syns när sidan laddas döljs aldrig, så inget blinkar och LCP påverkas inte.
     IntersectionObserver plus en scroll-reserv, så att inget kan bli kvar osynligt. */
  var REVEAL = [
    ['.c7-rule', 'line'],
    ['.c7-caps, .c7-title', 'develop'],
    ['.c7-body, .c7-modes__text, .c7-ghead__link, .c7-btn-pair, .c7-pill', 'rise'],
    ['.c7-modes__stage, .c7-inbox__visual, .c7-object__cam, .c7-events__img, .c7-events__panel, .c7-lab__img', 'photo'],
    ['.c7-specs, .c7-grid4, .c7-steps, .c7-inbox__list, .c7-faq__list, .c7-modes__tabs, .c7-bullets, .c7-offers, .c7-compare__table tbody', 'stagger']
  ];
  var pending = [];
  var io = null;
  function reveal(el) {
    if (el._c7In) return;
    el._c7In = true;
    el.classList.add('is-in');
    if (io) io.unobserve(el);
    pending = pending.filter(function (x) { return x !== el; });
    // När framkallningen är klar tas tillståndet bort, så att elementets egna
    // hover-övergångar gäller igen (utan stagger-fördröjning).
    setTimeout(function () {
      el.removeAttribute('data-c7-rv');
      el.classList.remove('is-in');
    }, 2000);
  }
  function sweep() {
    var h = window.innerHeight;
    pending.slice().forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < h * 0.92 && r.bottom > 0) reveal(el);
    });
  }
  function initMotion(root) {
    var html = document.documentElement;
    if (!html.classList.contains('c7-motion')) return;
    if (!io && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) reveal(en.target); });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    var h = window.innerHeight;
    REVEAL.forEach(function (pair) {
      root.querySelectorAll(pair[0]).forEach(function (el) {
        if (el.hasAttribute('data-c7-rv') || el.closest('.c7-hero, cart-drawer, .c7-menu, [data-c7-rv]')) return;
        if (el.getBoundingClientRect().top < h) return;
        if (pair[1] === 'stagger') {
          Array.prototype.forEach.call(el.children, function (c, i) { c.style.setProperty('--i', Math.min(i, 10)); });
        }
        el.setAttribute('data-c7-rv', pair[1]);
        pending.push(el);
        if (io) io.observe(el);
      });
    });
  }
  window.addEventListener('scroll', function () { if (pending.length) sweep(); }, { passive: true });

  /* ---------- Mjuk scroll med Lenis (assets/vendor-lenis.min.js) ----------
     Bara med mus/styrplatta: touch scrollar som vanligt. Av i temaeditorn och vid reducerad rörelse.
     Pausas när en låda, meny eller modal låser sidan, och rullar inte i scrollbara rutor. */
  var LOCK_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];
  function initSmoothScroll() {
    if (window.c7Lenis || typeof window.Lenis === 'undefined') return;
    if (!document.documentElement.classList.contains('c7-motion')) return;
    var lenis = new window.Lenis({
      lerp: 0.11,
      autoRaf: true,
      allowNestedScroll: true,
      anchors: { offset: -64 },
      prevent: function (node) {
        return !!(node.closest && node.closest('cart-drawer, .c7-menu, product-modal, details-modal, .predictive-search, [data-lenis-prevent]'));
      }
    });
    window.c7Lenis = lenis;
    var sync = function () {
      var b = document.body.classList;
      var locked = document.documentElement.style.overflow === 'hidden' || LOCK_CLASSES.some(function (c) { return b.contains(c); });
      if (locked) lenis.stop(); else lenis.start();
    };
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  }

  /* ---------- Språkväljare: stäng vid klick utanför eller Escape ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-c7-lang][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-c7-lang][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary');
      if (s) s.focus();
    });
  });

  /* ---------- UGC-videor: laddas och spelas när de syns, tryck = ljud på/av ---------- */
  function initUgc(root) {
    root.querySelectorAll('[data-c7-ugc]').forEach(function (sec) {
      if (sec.dataset.c7Bound) return;
      sec.dataset.c7Bound = '1';
      var track = sec.querySelector('[data-c7-ugc-track]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var play = function (v) {
        if (!v.getAttribute('src')) v.src = v.dataset.c7UgcSrc;
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      };
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.5) play(en.target);
            else if (!en.target.paused) en.target.pause();
          });
        }, { threshold: [0, 0.5, 1] });
        sec.querySelectorAll('video[data-c7-ugc-src]').forEach(function (v) { io.observe(v); });
      }
      sec.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-c7-ugc-sound]');
        if (!btn && e.target.matches('video[data-c7-ugc-src]')) btn = e.target.parentElement.querySelector('[data-c7-ugc-sound]');
        if (btn) {
          var v = btn.parentElement.querySelector('video');
          var turnOn = v.muted;
          sec.querySelectorAll('video').forEach(function (o) { o.muted = true; });
          sec.querySelectorAll('[data-c7-ugc-sound]').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
          if (turnOn) { v.muted = false; play(v); btn.setAttribute('aria-pressed', 'true'); }
          return;
        }
        var dir = e.target.closest('[data-c7-ugc-next]') ? 1 : e.target.closest('[data-c7-ugc-prev]') ? -1 : 0;
        if (dir && track) {
          var card = track.querySelector('.c7-ugc__card');
          var step = card ? card.getBoundingClientRect().width + 16 : 300;
          track.scrollBy({ left: dir * step * 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      });
    });
  }

  /* ---------- Nyhetsbrevs-popup (sections/7cam-popup) ----------
     Efter X sekunder, vid utgång (mus mot fliken på dator) eller halva sidan, det som kommer först.
     Högst en gång per 14 dagar. Efter anmälan laddar Shopify om sidan med #C7Popup: då visas koden. */
  var POP_KEY = 'c7-pop-seen';
  var popSeen = function () {
    try { var t = +localStorage.getItem(POP_KEY); return !!t && Date.now() - t < 14 * 864e5; } catch (e) { return false; }
  };
  var popMark = function () { try { localStorage.setItem(POP_KEY, String(Date.now())); } catch (e) {} };
  function initPopup(root) {
    var pop = root.querySelector('[data-c7-pop]');
    if (!pop || pop.dataset.c7Bound) return;
    pop.dataset.c7Bound = '1';
    var isOpen = false;
    var open = function () {
      if (isOpen || document.querySelector('cart-drawer.active')) return;
      isOpen = true;
      pop.hidden = false;
      setTimeout(function () { pop.classList.add('is-open'); }, 20);
      document.body.classList.add('overflow-hidden');
      popMark();
      var f = pop.querySelector('input[type="email"], [data-c7-pop-copy]');
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
    };
    var close = function () {
      if (!isOpen) return;
      isOpen = false;
      pop.classList.remove('is-open');
      document.body.classList.remove('overflow-hidden');
      setTimeout(function () { if (!isOpen) pop.hidden = true; }, 400);
    };
    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-c7-pop-close]')) return close();
      var c = e.target.closest('[data-c7-pop-copy]');
      if (c) {
        if (navigator.clipboard) navigator.clipboard.writeText(c.dataset.c7PopCopy).catch(function () {});
        c.textContent = c.dataset.copied;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (pop.dataset.design === 'true') {
      document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(pop)) open(); });
      document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(pop)) close(); });
      return;
    }
    // Tillbaka efter anmälan (eller fel i formuläret): visa direkt
    if (pop.querySelector('[data-c7-pop-done]') || location.hash === '#C7Popup') return open();
    if (popSeen()) return;
    setTimeout(open, (parseInt(pop.dataset.delay, 10) || 12) * 1000);
    var onScroll = function () {
      var h = document.documentElement;
      if (h.scrollTop / Math.max(1, h.scrollHeight - window.innerHeight) > 0.5) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
  }

  function init(root) {
    initPopup(root);
    initUgc(root);
    initMenu(root); initCountdowns(root); initBundles(root); initDelivery(root);
    initSticky(root); initModes(root); initShare(root); initVideos(root); initMotion(root);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); initSmoothScroll(); });
  } else {
    init(document);
    initSmoothScroll();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
